import getProfileStore from '../store/profileStore';

export enum StoreLoadingState {
    none = 'none',
    loading = 'loading',
    loaded = 'loaded',
    error = 'error',
}

export function getStoreLoadingState(): StoreLoadingState {
    // TODO implement proper loading and error handling
    // https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/114323
    return getProfileStore().accountSources.length === 0
        ? StoreLoadingState.loading
        : StoreLoadingState.loaded;
}
